<template>
    <b-container fluid style="padding-top: 10px">
        <vue-good-table
                v-if="true"
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed table-bordered table-striped"
                @on-row-click="onRowClick"
                :sort-options="{
                    enabled: true,
                    initialSortBy: {
                        field: 'loginDate',
                        type: 'desc'
                    }
                }"
                :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'Account Info'">
                    <b-button size="sm"
                              @click="goToAccountInfo(props.column.field,props.formattedRow[props.column.field])">
                            Account Info
                    </b-button>
                </span>
                <span v-else-if="props.column.label === 'Calculator'">
                    <b-button size="sm"
                              @click="goToCalculator(props.formattedRow[props.column.field])">Metrics Summary</b-button>
                </span>
                <span v-else-if="props.column.label === 'Certify'">
                    <b-button size="sm"
                              @click="certify(props.formattedRow['surveyId'], data.item.winery, props.formattedRow['groupId'])">
                    Certify
                    </b-button>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </b-container>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
  name: "LoginAdmin",
  components: {
    Datepicker,
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: "userId",
                        field: "userId"
                    },
                    {
                        label: "User Name",
                        field: "userName"
                    },
                    {
                        label: "IP Address",
                        field: "ipAddress"
                    },
                    {
                      label: "App Version",
                      field: "appVersion"
                    },
        {
                        label: "Login Date",
                        field: "loginDate",
                        type: 'date',

                        formatFn: value => {
                            if (value === "" || value === null) {
                                return "Unknown";
                            }

                            let date = new Date(0);

                            date.setUTCMilliseconds(value);

                            let options = {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric'
                            };
                            return date.toLocaleDateString("en-US", options)
                        }
                    },
          {
              label: "User Agent",
              field: "userAgent"
          }],
        items: [],
        rows: [],
        certificationDate: '',
        surveyToCertify: '',
        groupIdToCertify: ''
    }
  },
    mounted() {
        this.$http.get("admin/logins")
            .then(result => {
                this.rows = result.data;
            })
            .catch(error => {
                console.log("The error: " + error);
            })

    },
    methods: {
            isNotCertifier: function () {
                return !localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER");
            },
            selected(item) {
                localStorage.setItem('adminImpersonationGroupId', item.groupId);
              this.$store.commit("adminImpersonationGroupId", item.groupId);
                this.$router.push({name: 'SurveyLink', params: {surveyKey: item.surveyId, groupId: item.groupId}});
            },
            onRowClick(params) {
                console.log("The item: ");
                console.log(params);
            },
            certify: function (surveyIdValue, wineryName, groupId) {
                this.$bvModal.show("modal-1");
                this.surveyToCertify = surveyIdValue;
                this.groupIdToCertify = groupId;

            },
            goToCalculator: function (group) {
                localStorage.setItem('adminImpersonationGroupId', group);
              this.$store.commit("adminImpersonationGroupId", group);
                this.$router.push({name: "TabbedMetrics", params: {groupId: group}})
                    .catch(err => {
                    });
            },
            goToAccountInfo: function (wineryName, groupId) {
                localStorage.setItem('adminImpersonationGroupId', groupId);
              this.$store.commit("adminImpersonationGroupId", groupId);
                this.$router.push({name: "Update_Account", params: {groupId: groupId}})
                    .catch(err => {
                        //Link did not work.
                    });
            },
            dismissTheModal: function () {
                this.$bvModal.hide("modal-1");
                this.surveyToCertify = '';
                this.groupIdToCertify = '';
                this.certificationDate = '';
            },
            saveAction: function () {
                this.$bvModal.hide("modal-1");
                let certRequest = {
                    certificationDate: new Date(this.certificationDate),
                    surveyResponseId: this.surveyToCertify,
                    certifierId: localStorage.getItem('user'),
                    groupId: this.groupIdToCertify
                }

                let inviteRequestJson = JSON.stringify(certRequest, null, 3);
                this.$http.post("survey/certify", inviteRequestJson
                    , {
                        headers: {
                            'content-type': 'application/json'
                        }
                    })
                    .then(response => {
                        console.log(response);
                        swal({
                            title: "Group has been Certified",
                            type: "success",
                            timer: 3000
                        });
                    })
                    .catch(fail => {
                        swal(" Certification Attempt Failed. [" + fail + "]");
                    });
            }
        }
    }
</script>
